import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=b1ffd708&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=b1ffd708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ffd708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1ffd708')) {
      api.createRecord('b1ffd708', component.options)
    } else {
      api.reload('b1ffd708', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=b1ffd708&scoped=true&", function () {
      api.rerender('b1ffd708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29NbHHp5A2ZRL/JS/comp/Voucher.vue"
export default component.exports